"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasisTheoryProxies = require("./BasisTheoryProxies");

Object.keys(_BasisTheoryProxies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasisTheoryProxies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasisTheoryProxies[key];
    }
  });
});